export const REVIEW_REPEAT_VALUES = {
  BEFORE: 'BEFORE_PERIOD_END',
  AFTER: 'AFTER_PERIOD_END',
  END: 'AT_PERIOD_END'
}

export const REVIEW_REPEAT_OPTIONS = [
  { label: 'Before period', value: REVIEW_REPEAT_VALUES.BEFORE },
  { label: 'After period end', value: REVIEW_REPEAT_VALUES.AFTER },
  { label: 'At period end', value: REVIEW_REPEAT_VALUES.END }
]

export const REVIEW_TYPE_VALUES = {
  DAYS: 'DAYS',
  WEEKS: 'WEEKS',
  MONTHS: 'MONTHS'
}

export const REVIEW_TYPE_OPTIONS = [
  { label: 'Day(s)', value: REVIEW_TYPE_VALUES.DAYS },
  { label: 'Week(s)', value: REVIEW_TYPE_VALUES.WEEKS },
  { label: 'Month(s)', value: REVIEW_TYPE_VALUES.MONTHS }
]

export const REVIEW_EDIT_VALUES = {
  THIS: 'THIS',
  ALL: 'ALL'
}

export const REVIEW_EDIT_OPTIONS = [
  { label: 'This event', value: REVIEW_EDIT_VALUES.THIS },
  { label: 'This and future events', value: REVIEW_EDIT_VALUES.ALL }
]

export const REVIEW_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE'
}
